module.exports = __webpack_public_path__ + "static/media/credit.13585002.svg";